export const version = '1.1.1';
//# sourceMappingURL=version.js.map